let isRefreshing = false
let failedQueue: Array<{
	resolve: (token: string) => void
	reject: (error: any) => void
}> = []

export const getIsRefreshing = () => isRefreshing

export const setIsRefreshing = (state: boolean) => {
	isRefreshing = state
}

export const addToQueue = () => {
	return new Promise<string>((resolve, reject) => {
		failedQueue.push({ resolve, reject })
	})
}

export const processQueue = (error: any, token: string | null = null) => {
	failedQueue.forEach(prom => {
		if (error) {
			prom.reject(error)
		} else if (token) {
			prom.resolve(token)
		}
	})
	failedQueue = []
}
